var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"score"},_vm._l((_vm.activities),function(item){return _c('div',{key:item.order,staticClass:"score__item",class:_vm.computedClass(item),attrs:{"data-score-item":""}},[_vm._v(" "+_vm._s(item.order + 1)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }